'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends$1 = require('../../extends-733dd656.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var styled = require('styled-components');
require('../../unsupportedIterableToArray-f175acfa.js');
var slicedToArray = require('../../slicedToArray-a8a77f0e.js');
var utils_isType_isType = require('../../utils/isType/isType.js');
var defineProperty = require('../../defineProperty-3cad0327.js');
var formik_esm = require('../../formik.esm-e131ccca.js');
require('../../utils/string/isString.js');
var FormContext = require('../../FormContext-74eaf8f0.js');
var utils_string_trim = require('../../utils/string/trim.js');
var utils_object_mergeMatchingProperties = require('../../utils/object/mergeMatchingProperties.js');
var utils_email_isValid = require('../../utils/email/isValid.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function sanitizedFormValues(values) {
  return Object.keys(values).reduce(function (result, field) {
    return _extends$1._extends_1({}, result, defineProperty.defineProperty({}, field, utils_string_trim.trim(values[field])));
  }, {});
}

function useFormErrorMessage() {
  var _useState = React.useState(''),
      _useState2 = slicedToArray.slicedToArray(_useState, 2),
      formErrorMsg = _useState2[0],
      setFormErrorMsg = _useState2[1];

  function clearFormErrorMsg() {
    setFormErrorMsg('');
  }

  return {
    formErrorMsg: formErrorMsg,
    setFormErrorMsg: setFormErrorMsg,
    clearFormErrorMsg: clearFormErrorMsg
  };
}

function FormStructure(_ref) {
  var children = _ref.children,
      enableReinitialize = _ref.enableReinitialize,
      initialTouched = _ref.initialTouched,
      initialValues = _ref.initialValues,
      noValidate = _ref.noValidate,
      onSubmit = _ref.onSubmit;
  var formErrorMessage = useFormErrorMessage();
  var formStepControls = FormContext.useStepControls();

  var _useFormData = FormContext.useFormData(),
      setFormStepValues = _useFormData.setFormStepValues,
      formsValues = _useFormData.formsValues;

  function handleSubmit(fieldsValues, _ref2) {
    var setSubmitting = _ref2.setSubmitting,
        setErrors = _ref2.setErrors;
    var sanitizedValues = sanitizedFormValues(fieldsValues);

    function setFormErrors(fieldsErrorsMap) {
      var mappedErrors = utils_object_mergeMatchingProperties.strictlyMergeMatchingProperties(fieldsValues, fieldsErrorsMap);
      setErrors(mappedErrors);
    }

    Promise.resolve().then(function () {
      setFormStepValues(sanitizedValues);
      return onSubmit(_extends$1._extends_1({
        formsValues: formsValues,
        setFormErrors: setFormErrors,
        setSubmitting: setSubmitting,
        values: sanitizedValues
      }, formErrorMessage, formStepControls));
    }) // Async function has a need a catch block
    // Without this treatment it is possible to cause errors in promises and the tests with Jest
    ["catch"](function (err) {
      console.error('Formik submit error', err);
    });
  }

  var mergedValues = React.useMemo(function () {
    return utils_object_mergeMatchingProperties.mergeMatchingProperties(initialValues, formsValues);
  }, [initialValues]);
  return /*#__PURE__*/React__default['default'].createElement(formik_esm.Formik, {
    initialValues: mergedValues,
    initialTouched: initialTouched,
    onSubmit: handleSubmit,
    validateOnMount: true,
    enableReinitialize: enableReinitialize
  }, function (_ref3) {
    var isSubmitting = _ref3.isSubmitting,
        isValid = _ref3.isValid,
        setFieldValue = _ref3.setFieldValue,
        values = _ref3.values;

    var formikStepAPI = _extends$1._extends_1({
      setFieldValue: setFieldValue,
      currentStepValues: values,
      isDisabled: !isValid,
      isSubmitting: isSubmitting,
      formsValues: formsValues
    }, formStepControls, formErrorMessage);

    return /*#__PURE__*/React__default['default'].createElement(formik_esm.Form, {
      noValidate: noValidate
    }, children(formikStepAPI));
  });
}

FormStructure.defaultProps = {
  enableReinitialize: false,
  initialTouched: {},
  initialValues: {},
  noValidate: false,
  onSubmit: function onSubmit() {}
};
FormStructure.propTypes = {
  children: index.propTypes.oneOfType([index.propTypes.node, index.propTypes.func]).isRequired,
  enableReinitialize: index.propTypes.bool,
  initialTouched: index.propTypes.objectOf(index.propTypes.any),
  initialValues: index.propTypes.objectOf(index.propTypes.any),
  noValidate: index.propTypes.bool,
  onSubmit: index.propTypes.func
};

var FormStepRenderChildren = function FormStepRenderChildren(_ref) {
  var children = _ref.children,
      props = objectWithoutProperties.objectWithoutProperties(_ref, ["children"]);

  var formStepAPI = _extends$1._extends_1({}, FormContext.useStepControls(), FormContext.useFormData());

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, utils_isType_isType.isType('function', children) ? children(_extends$1._extends_1({}, props, formStepAPI)) : children);
};

FormStepRenderChildren.propTypes = {
  children: index.propTypes.oneOfType([index.propTypes.node, index.propTypes.func]).isRequired
};

function FormStep(_ref) {
  var children = _ref.children,
      enableReinitialize = _ref.enableReinitialize,
      initialTouched = _ref.initialTouched,
      initialValues = _ref.initialValues,
      isForm = _ref.isForm,
      noValidate = _ref.noValidate,
      onSubmit = _ref.onSubmit;

  // TODO: mapear o initial values de forma auto-mágica.
  if (isForm) {
    return /*#__PURE__*/React__default['default'].createElement(FormStructure, {
      initialValues: initialValues,
      initialTouched: initialTouched,
      enableReinitialize: enableReinitialize,
      onSubmit: onSubmit,
      noValidate: noValidate
    }, function (props) {
      return /*#__PURE__*/React__default['default'].createElement(FormStepRenderChildren, props, children);
    });
  }

  return /*#__PURE__*/React__default['default'].createElement(FormStepRenderChildren, null, children);
}

FormStep.defaultProps = {
  enableReinitialize: false,
  initialValues: {},
  initialTouched: {},
  isForm: true,
  noValidate: false,
  onSubmit: function onSubmit() {}
};
FormStep.propTypes = {
  children: index.propTypes.oneOfType([index.propTypes.node, index.propTypes.func]).isRequired,
  enableReinitialize: index.propTypes.bool,
  initialTouched: index.propTypes.objectOf(index.propTypes.any),
  initialValues: index.propTypes.objectOf(index.propTypes.any),
  isForm: index.propTypes.bool,
  noValidate: index.propTypes.bool,
  onSubmit: index.propTypes.func
};

var equalsTo = function equalsTo() {
  var fieldValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    target: ''
  };
  var formValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var hasTargetInFormValues = Object.prototype.hasOwnProperty.call(formValues, params.target);

  if (!hasTargetInFormValues) {
    throw new Error("Your form does not have a field with target: ".concat(params.target));
  }

  var targetValue = formValues[params.target];
  var isValid = fieldValue === targetValue;
  return isValid;
};

var isRequired = function isRequired() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (utils_isType_isType.isType('boolean', value)) {
    return value;
  }

  return Boolean(value.length);
};

var validationFunctions = {
  required: isRequired,
  email: utils_email_isValid.isEmailValid,
  equalsTo: equalsTo
};
var formValidationPropType = index.propTypes.objectOf(index.propTypes.func);

var FormWrapper = styled__default['default'].div.withConfig({
  displayName: "FormWrapper",
  componentId: "sc-1r3xsxy-0"
})(["width:100%;"]);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var LEFT = "Left";
var RIGHT = "Right";
var UP = "Up";
var DOWN = "Down";

var defaultProps = {
  delta: 10,
  preventDefaultTouchmoveEvent: false,
  rotationAngle: 0,
  trackMouse: false,
  trackTouch: true
};
var initialState = {
  first: true,
  initial: [0, 0],
  start: 0,
  swiping: false,
  xy: [0, 0]
};
var mouseMove = "mousemove";
var mouseUp = "mouseup";
var touchEnd = "touchend";
var touchMove = "touchmove";
var touchStart = "touchstart";

function getDirection(absX, absY, deltaX, deltaY) {
  if (absX > absY) {
    if (deltaX > 0) {
      return RIGHT;
    }

    return LEFT;
  } else if (deltaY > 0) {
    return DOWN;
  }

  return UP;
}

function rotateXYByAngle(pos, angle) {
  if (angle === 0) return pos;
  var angleInRadians = Math.PI / 180 * angle;
  var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
  var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
  return [x, y];
}

function getHandlers(set, handlerProps) {
  var onStart = function onStart(event) {
    // if more than a single touch don't track, for now...
    if (event && "touches" in event && event.touches.length > 1) return;
    set(function (state, props) {
      // setup mouse listeners on document to track swipe since swipe can leave container
      if (props.trackMouse) {
        document.addEventListener(mouseMove, onMove);
        document.addEventListener(mouseUp, onUp);
      }

      var _ref = "touches" in event ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
      return _extends({}, state, initialState, {
        initial: [].concat(xy),
        xy: xy,
        start: event.timeStamp || 0
      });
    });
  };

  var onMove = function onMove(event) {
    set(function (state, props) {
      // Discount a swipe if additional touches are present after
      // a swipe has started.
      if ("touches" in event && event.touches.length > 1) {
        return state;
      }

      var _ref2 = "touches" in event ? event.touches[0] : event,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
          x = _rotateXYByAngle[0],
          y = _rotateXYByAngle[1];

      var deltaX = x - state.xy[0];
      var deltaY = y - state.xy[1];
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      var time = (event.timeStamp || 0) - state.start;
      var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
      var vxvy = [deltaX / (time || 1), deltaY / (time || 1)]; // if swipe is under delta and we have not started to track a swipe: skip update

      if (absX < props.delta && absY < props.delta && !state.swiping) return state;
      var dir = getDirection(absX, absY, deltaX, deltaY);
      var eventData = {
        absX: absX,
        absY: absY,
        deltaX: deltaX,
        deltaY: deltaY,
        dir: dir,
        event: event,
        first: state.first,
        initial: state.initial,
        velocity: velocity,
        vxvy: vxvy
      };
      props.onSwiping && props.onSwiping(eventData); // track if a swipe is cancelable(handler for swiping or swiped(dir) exists)
      // so we can call preventDefault if needed

      var cancelablePageSwipe = false;

      if (props.onSwiping || props.onSwiped || "onSwiped" + dir in props) {
        cancelablePageSwipe = true;
      }

      if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault();
      return _extends({}, state, {
        // first is now always false
        first: false,
        eventData: eventData,
        swiping: true
      });
    });
  };

  var onEnd = function onEnd(event) {
    set(function (state, props) {
      var eventData;

      if (state.swiping && state.eventData) {
        eventData = _extends({}, state.eventData, {
          event: event
        });
        props.onSwiped && props.onSwiped(eventData);
        var onSwipedDir = "onSwiped" + eventData.dir;

        if (onSwipedDir in props) {
          props[onSwipedDir](eventData);
        }
      } else {
        props.onTap && props.onTap({
          event: event
        });
      }

      return _extends({}, state, initialState, {
        eventData: eventData
      });
    });
  };

  var cleanUpMouse = function cleanUpMouse() {
    // safe to just call removeEventListener
    document.removeEventListener(mouseMove, onMove);
    document.removeEventListener(mouseUp, onUp);
  };

  var onUp = function onUp(e) {
    cleanUpMouse();
    onEnd(e);
  };
  /**
   * Switch of "passive" property for now.
   * When `preventDefaultTouchmoveEvent` is:
   * - true => { passive: false }
   * - false => { passive: true }
   *
   * Could take entire `addEventListener` options object as a param later?
   */


  var attachTouch = function attachTouch(el, passive) {
    var cleanup = function cleanup() {};

    if (el && el.addEventListener) {
      // attach touch event listeners and handlers
      var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
      tls.forEach(function (_ref3) {
        var e = _ref3[0],
            h = _ref3[1];
        return el.addEventListener(e, h, {
          passive: passive
        });
      }); // return properly scoped cleanup method for removing listeners, options not required

      cleanup = function cleanup() {
        return tls.forEach(function (_ref4) {
          var e = _ref4[0],
              h = _ref4[1];
          return el.removeEventListener(e, h);
        });
      };
    }

    return cleanup;
  };

  var onRef = function onRef(el) {
    // "inline" ref functions are called twice on render, once with null then again with DOM element
    // ignore null here
    if (el === null) return;
    set(function (state, props) {
      // if the same DOM el as previous just return state
      if (state.el === el) return state;
      var addState = {}; // if new DOM el clean up old DOM and reset cleanUpTouch

      if (state.el && state.el !== el && state.cleanUpTouch) {
        state.cleanUpTouch();
        addState.cleanUpTouch = undefined;
      } // only attach if we want to track touch


      if (props.trackTouch && el) {
        addState.cleanUpTouch = attachTouch(el, !props.preventDefaultTouchmoveEvent);
      } // store event attached DOM el for comparison, clean up, and re-attachment


      return _extends({}, state, {
        el: el
      }, addState);
    });
  }; // set ref callback to attach touch event listeners


  var output = {
    ref: onRef
  }; // if track mouse attach mouse down listener

  if (handlerProps.trackMouse) {
    output.onMouseDown = onStart;
  }

  return [output, attachTouch];
}

function updateTransientState(state, props, attachTouch) {
  var addState = {}; // clean up touch handlers if no longer tracking touches

  if (!props.trackTouch && state.cleanUpTouch) {
    state.cleanUpTouch();
    addState.cleanUpTouch = undefined;
  } else if (props.trackTouch && !state.cleanUpTouch) {
    // attach/re-attach touch handlers
    if (state.el) {
      addState.cleanUpTouch = attachTouch(state.el, !props.preventDefaultTouchmoveEvent);
    }
  }

  return _extends({}, state, addState);
}

function useSwipeable(options) {
  var trackMouse = options.trackMouse;
  var transientState = React.useRef(_extends({}, initialState));
  var transientProps = React.useRef(_extends({}, defaultProps));
  transientProps.current = _extends({}, defaultProps, options);

  var _React$useMemo = React.useMemo(function () {
    return getHandlers(function (stateSetter) {
      return transientState.current = stateSetter(transientState.current, transientProps.current);
    }, {
      trackMouse: trackMouse
    });
  }, [trackMouse]),
      handlers = _React$useMemo[0],
      attachTouch = _React$useMemo[1];

  transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
  return handlers;
}

var _PREV = 'PREV';
var _NEXT = 'NEXT';
var SLIDE_TO = 'SLIDE_TO';
var STOP_SLIDING = 'STOP_SLIDING';
var getSwipeableCSSSlideOrder = function getSwipeableCSSSlideOrder(_ref) {
  var index = _ref.index,
      swipeableStepIndex = _ref.swipeableStepIndex,
      numItems = _ref.numItems;
  var baseOrder = 0;
  var indexToCSSOrder = index - swipeableStepIndex;
  var isIndexToCSSOrderNegative = indexToCSSOrder < baseOrder;

  if (isIndexToCSSOrderNegative) {
    var positiveIndexToCSSOrder = numItems - Math.abs(indexToCSSOrder);
    return positiveIndexToCSSOrder;
  }

  return indexToCSSOrder;
};
var actions = {
  PREV: function PREV(state, _ref2) {
    var numItems = _ref2.numItems;
    var prevStepIndex = state.stepIndex - 1;
    var prevSwipeableStepIndex = state.swipeableStepIndex === 0 ? numItems - 1 : state.swipeableStepIndex - 1;
    var futureStepIndex = prevStepIndex < 0 ? numItems - 1 : prevStepIndex;
    return _extends$1._extends_1({}, state, {
      slideToDirection: _PREV,
      sliding: futureStepIndex !== state.stepIndex,
      swipeableStepIndex: prevSwipeableStepIndex,
      stepIndex: futureStepIndex
    });
  },
  NEXT: function NEXT(state, _ref3) {
    var numItems = _ref3.numItems;
    var nextStepIndex = state.stepIndex + 1;
    var futureStepIndex = nextStepIndex >= numItems ? 0 : nextStepIndex;
    var isSwipeableStepIndexEqualFirstChildIndex = state.swipeableStepIndex === numItems - 1;
    var nextSwipeableStepIndex = isSwipeableStepIndexEqualFirstChildIndex ? 0 : state.swipeableStepIndex + 1;
    return _extends$1._extends_1({}, state, {
      slideToDirection: _NEXT,
      sliding: futureStepIndex !== state.stepIndex,
      swipeableStepIndex: nextSwipeableStepIndex,
      stepIndex: futureStepIndex
    });
  },
  SLIDE_TO: function SLIDE_TO(state, _ref4) {
    var nextSlideNumber = _ref4.nextSlideNumber,
        numItems = _ref4.numItems;
    var isNextSlideNumberFirstSwipeableChildIndex = nextSlideNumber === 0;
    var futureSwipeableStepIndex = isNextSlideNumberFirstSwipeableChildIndex ? numItems - 1 : nextSlideNumber - 1;
    var futureDirection = nextSlideNumber > state.stepIndex ? _NEXT : _PREV;
    var hasSliding = nextSlideNumber !== state.stepIndex;
    return _extends$1._extends_1({}, state, {
      sliding: hasSliding,
      swipeableStepIndex: futureSwipeableStepIndex,
      slideToDirection: futureDirection,
      stepIndex: nextSlideNumber
    });
  },
  STOP_SLIDING: function STOP_SLIDING(state) {
    return _extends$1._extends_1({}, state, {
      sliding: false
    });
  }
};

function carouselReducer(state) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    slideToDirection: _NEXT,
    sliding: false
  };

  var executeAction = actions[action.type] || function () {
    return state;
  };

  return executeAction(state, action);
}

function useCarousel(initialState, totalChildren, transitionDurationInMs) {
  var _useReducer = React.useReducer(carouselReducer, initialState),
      _useReducer2 = slicedToArray.slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var transitionDurationNumber = Number(transitionDurationInMs.replace('ms'));

  var slide = function slide(slideToDirection) {
    var nextSlideNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    dispatch({
      type: slideToDirection,
      numItems: totalChildren,
      nextSlideNumber: nextSlideNumber
    });
    setTimeout(function () {
      return dispatch({
        type: STOP_SLIDING
      });
    }, transitionDurationNumber);
  };

  return {
    state: state,
    prevStep: function prevStep() {
      return slide(_PREV);
    },
    nextStep: function nextStep() {
      return slide(_NEXT);
    },
    goToStep: function goToStep(stepNumber) {
      return slide(SLIDE_TO, stepNumber);
    }
  };
}

var slidesGutter = '1em';

var handleSlideTransition = function handleSlideTransition(_ref) {
  var sliding = _ref.sliding,
      slideToDirection = _ref.slideToDirection;

  if (!sliding) {
    return "translateX(calc(-100% - ".concat(slidesGutter, "))");
  }

  if (slideToDirection === _PREV) {
    return "translateX(calc(2 * (-100% - ".concat(slidesGutter, ")))");
  }

  return 'translateX(0%)';
};

var CarouselContainer = styled__default['default'].div.withConfig({
  displayName: "CarouselContainer",
  componentId: "sc-1iq9b5w-0"
})(["display:flex;transition:", ";transform:", ";"], function (props) {
  return props.sliding ? 'none' : "transform ".concat(props.transitionDurationInMs, " cubic-bezier(0.23, 1, 0.32, 1)");
}, handleSlideTransition);
CarouselContainer.displayName = 'CarouselContainer';
CarouselContainer.propTypes = {
  slideToDirection: index.propTypes.oneOf([_PREV, _NEXT]).isRequired,
  sliding: index.propTypes.bool.isRequired,
  transitionDurationInMs: index.propTypes.string.isRequired
};
var CarouselSlot = styled__default['default'].div.withConfig({
  displayName: "CarouselContainer__CarouselSlot",
  componentId: "sc-1iq9b5w-1"
})(["flex:1 0 100%;margin-right:", ";", ";transition:", ";"], slidesGutter, function (_ref2) {
  var order = _ref2.order;
  return "\n    order: ".concat(order, ";\n    opacity: ").concat(order === 1 ? '1' : '0', ";\n  ");
}, function (props) {
  return "opacity ".concat(props.transitionDurationInMs, " cubic-bezier(0.23, 1, 0.32, 1)");
});
CarouselSlot.displayName = 'CarouselSlot';
CarouselContainer.defaultProps = {
  order: 0
};
CarouselContainer.propTypes = {
  order: index.propTypes.number.isRequired
};

var Wrapper = styled__default['default'].div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-12umhvv-0"
})(["width:100%;overflow:hidden;"]);

var FormStepTransitionManager = function FormStepTransitionManager(_ref) {
  var children = _ref.children,
      state = _ref.state,
      totalChildren = _ref.totalChildren,
      className = _ref.className,
      transitionDurationInMs = _ref.transitionDurationInMs;
  var handlers = useSwipeable({
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: className
  }, /*#__PURE__*/React__default['default'].createElement(Wrapper, handlers, /*#__PURE__*/React__default['default'].createElement(CarouselContainer, {
    slideToDirection: state.slideToDirection,
    sliding: state.sliding,
    transitionDurationInMs: transitionDurationInMs
  }, React__default['default'].Children.map(children, function (child, index) {
    return /*#__PURE__*/React__default['default'].createElement(CarouselSlot, {
      transitionDurationInMs: transitionDurationInMs,
      order: getSwipeableCSSSlideOrder({
        index: index,
        swipeableStepIndex: state.swipeableStepIndex,
        numItems: totalChildren
      })
    }, child);
  }))));
};

FormStepTransitionManager.defaultProps = {
  className: ''
};
FormStepTransitionManager.propTypes = {
  children: index.propTypes.node.isRequired,
  className: index.propTypes.string,
  state: index.propTypes.shape({
    slideToDirection: index.propTypes.string,
    sliding: index.propTypes.bool,
    swipeableStepIndex: index.propTypes.number
  }).isRequired,
  totalChildren: index.propTypes.number.isRequired,
  transitionDurationInMs: index.propTypes.string.isRequired
};

function renderChildren(children, state) {
  return React__default['default'].Children.map(children, function (child, index) {
    if (index !== state.stepIndex) {
      return null;
    }

    return child;
  });
}

function Form(_ref) {
  var extraValidations = _ref.extraValidations,
      children = _ref.children,
      className = _ref.className,
      enableStepTransition = _ref.enableStepTransition,
      renderHeader = _ref.renderHeader;
  var transitionDurationInMs = '500ms';
  var totalChildren = React.useMemo(function () {
    return React__default['default'].Children.count(children);
  }, [children]); // TODO: The first item must to be the value below because swipeable has a bug.

  var initialSwipeableItem = totalChildren - 1;
  var initialState = {
    swipeableStepIndex: initialSwipeableItem,
    stepIndex: 0
  };

  var _useCarousel = useCarousel(initialState, totalChildren, transitionDurationInMs),
      nextStep = _useCarousel.nextStep,
      prevStep = _useCarousel.prevStep,
      state = _useCarousel.state,
      goToStep = _useCarousel.goToStep;

  var validations = _extends$1._extends_1({}, validationFunctions, extraValidations);

  return /*#__PURE__*/React__default['default'].createElement(FormWrapper, {
    className: className
  }, renderHeader({
    totalSteps: totalChildren,
    prevStep: prevStep,
    currentStep: state.stepIndex + 1
  }), /*#__PURE__*/React__default['default'].createElement(FormContext.FormContextProvider, {
    value: {
      validations: validations,
      prevStep: prevStep,
      nextStep: nextStep,
      goToStep: goToStep
    }
  }, enableStepTransition ? /*#__PURE__*/React__default['default'].createElement(FormStepTransitionManager, {
    state: state,
    transitionDurationInMs: transitionDurationInMs,
    totalChildren: totalChildren
  }, children) : renderChildren(children, state)));
}

Form.Step = FormStep;
Form.defaultProps = {
  className: undefined,
  enableStepTransition: false,
  extraValidations: {},
  renderHeader: function renderHeader() {}
};
Form.propTypes = {
  children: index.propTypes.node.isRequired,
  className: index.propTypes.string,
  enableStepTransition: index.propTypes.bool,
  extraValidations: formValidationPropType,
  renderHeader: index.propTypes.func
};

exports.default = Form;
exports.useCarousel = useCarousel;
//# sourceMappingURL=Form.js.map
